import React, { useContext, useState } from 'react';
import propTypes from 'prop-types';
import { Button, Grid } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import EditorControls from '../../BaseEditor/editorControls';
import { AppContext } from '../../../providers/authProvider';
import { LogicaContext } from '../../../providers/authLogicaProvider';

function DKSUDates({
  year, setYear, getDKSUDates, logicaPingSuccess,
}) {
  const { currentUser } = useContext(AppContext);
  const {
    ticket,
    setTicket,
  } = useContext(LogicaContext);
  const [newTicket, setNewTicket] = useState(ticket);
  return (
    <Grid container spacing={2}>
      <Grid item sm={3}>
        <EditorControls.StringInput
          label="Рік"
          required
          value={year}
          onChange={(e) => setYear(e.target.value)}
        />
      </Grid>
      <Grid item sm={1} display="flex" alignItems="center" justifyContent="start">
        <Button
          onClick={getDKSUDates}
          disabled={!logicaPingSuccess}
          color="primary"
          variant="contained"
          startIcon={<FontAwesomeIcon icon={faSearch} />}
        >
          Пошук
        </Button>
      </Grid>

      {currentUser.is_superuser && (
      <Grid item sm={11}>
        <EditorControls.TextInput
          controlId="ticket"
          label="ticket"
          value={newTicket}
          onChange={(e, v) => {
            setNewTicket(v);
          }}
        />
        <Button
          onClick={() => setTicket(newTicket)}
          disabled={!logicaPingSuccess}
          color="primary"
          variant="contained"
        >
          Встановити новий Ticket
        </Button>
      </Grid>
      )}

    </Grid>
  );
}

DKSUDates.propTypes = {
  year: propTypes.string.isRequired,
  setYear: propTypes.func.isRequired,
  getDKSUDates: propTypes.func.isRequired,
  logicaPingSuccess: propTypes.bool.isRequired,
};

export default DKSUDates;
